import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface Project {
  id: string;
  name: string;
  hubId: string;
  hubName?: string;
  status: string;
  urlProjectId?: string; // URL-friendly project identifier
  databaseId?: string; // Database ID for URL routing
  account?: string; // Account/hub name for display
}

interface AppState {
  selectedProject: Project | null;
  setSelectedProject: (project: Project | null) => void;
  projects: Project[];
  setProjects: (projects: Project[]) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      selectedProject: null,
      setSelectedProject: (project) => set({ selectedProject: project }),
      projects: [],
      setProjects: (projects) => set({ projects }),
    }),
    {
      name: "handover-helper-storage", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);
